import { Box, Container, Grid, Stack, styled, Typography } from "@mui/material";
import React from "react";
import { allIcons, allImages } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";
import { useNavigate } from "react-router-dom";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "100vh",
  backgroundColor: "#000000",
  [theme.breakpoints.down("sm")]: {
    height: "auto",
  },

  "& .lpl_viewcon": {
    height: "inherit",
    position: "relative",
    height: "100vh",
    color: "#ffffff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    zIndex: 999,
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      padding: "2rem 16px",
    },
  },

  "& .home_bg_image": {
    position: "absolute",
    bottom: 0,
    right: 0,
    zIndex: 2,
    [theme.breakpoints.down("md")]: {
      opacity: 0.4,
    },
    [theme.breakpoints.down("sm")]: {
      height: "50%",
      opacity: 0.4,
      top: 0,
    },
  },
  "& .home_line_image": {
    position: "absolute",
    bottom: 0,
    zIndex: 1,
  },

  "& .lpl_text_pr": {
    fontWeight: 600,
    fontSize: "4rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  "& .lpl_text_sr": {
    fontWeight: 300,
    maxWidth: "600px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
    },
  },
}));

function Banner() {
  const navigate = useNavigate();
  const landingViewImages = [
    allIcons.landingView1,
    allIcons.landingView2,
    allIcons.landingView3,
    allIcons.landingView4,
    allIcons.landingView5,
  ];
  return (
    <MainView>
      {/* background image */}
      <img
        className="home_bg_image"
        src={allImages.landingHomeBgImage}
        alt="home-bg-image"
        height={"100%"}
      />
      <img
        className="home_line_image"
        src={allImages.landingHomeLineImage}
        alt="home-bg-image"
        width={"100%"}
      />
      <Container maxWidth={"lg"} className="lpl_viewcon">
        <Typography variant="h1" className="lpl_text_pr">
          Get Your Own Salon
        </Typography>

        <Typography variant="h1" className="lpl_text_pr">
          Appointment Platform
        </Typography>
        <Typography mt={2.5} variant={"h6"} className={"lpl_text_sr"}>
          An all-in-one SaaS platform that helps you manage bookings, clients,
          services, team performance, and growth — all in one place, and with
          zero hassle. Start free and see how easy success can be.
        </Typography>
        <Stack
          mt={{ xs: 6, md: 4 }}
          direction={{ xs: "column", sm: "row" }}
          alignItems={"center"}
          gap={1.5}
        >
          <GlobalButton
            btnText={"Start with free"}
            styleProps={{ width: { xs: "100%", md: 200 } }}
            handleClickBtn={() => navigate("/sign-up")}
          />
          <GlobalButton
            variant={"none"}
            btnText={"View Demo"}
            startIcon={
              <img
                src={allIcons.playVideoIcon}
                alt="playvideo-icon"
                width={20}
              />
            }
            styleProps={{ width: { xs: "100%", md: 200 }, height: 45 }}
          />
        </Stack>
        <Stack
          my={4}
          direction={{ xs: "column", sm: "row" }}
          alignItems={"center"}
          gap={5}
        >
          <Box>
            <Typography variant="body2">Trusted by</Typography>
            <Typography variant="body2">Leading Companies</Typography>
          </Box>

          <Stack direction={"row"} alignItems={"center "} gap={3}>
            {landingViewImages?.map((val, ind) => {
              return <img src={val} alt="icons" width={30} key={ind} />;
            })}
          </Stack>
        </Stack>
      </Container>
    </MainView>
  );
}

export default Banner;
